import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard,{attrs:{"outlined":""}},[_c(VCardText,[_c('h4',{staticClass:"d-block mb-4"},[_vm._v("Essgewohnheiten verbessern")]),(_vm.chartData)?_c('chart-line',{attrs:{"height":250,"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }